var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 38,
    viewBox: "0 0 36 38",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-7 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.998 10c.002-2.21-4.478-4-9.998-4s-9.996 1.792-10 4c0 2.21 4.476 4 10 4s10-1.79 10-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 10v15.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.002 18c0 2.21 4.476 4 10 4s10-1.79 10-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.364 26.636c3.514 3.514 3.514 9.214 0 12.728s-9.214 3.514-12.728 0-3.514-9.214 0-12.728 9.214-3.514 12.728 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.01 28.85c-1.804.71-4.278 1.15-7.01 1.15-5.522 0-9.998-1.79-9.998-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.89 36.888c-1.794.686-4.212 1.112-6.89 1.112-5.522 0-9.998-1.79-10-4v-24"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.19ad03fa8016d5f251d8eb2b0d7b4c64.svg";
export { ForwardRef as ReactComponent };